import { TimeOfDay } from "@smart/bridge-types-basic";
import { RadioButtons } from "@smart/itops-sb-design-system-dom";

import {
  formatTimeOfDay,
  timeOfDayInMinutes,
  toTimeOfDay,
} from "../../../utils";

const toTimeOfDayFromMinutesString = (minutes: string): TimeOfDay =>
  toTimeOfDay(parseInt(minutes, 10));

type TimePickerProps = {
  heading?: string;
  selectedTime?: TimeOfDay | null;
  availableTimes?: TimeOfDay[];
  onSelect: (slot: TimeOfDay) => void;
};

export const TimePicker = ({
  heading,
  selectedTime,
  availableTimes,
  onSelect,
}: TimePickerProps) => (
  <div
    className="flex flex-col w-full tablet:border-l-[1px] border-neutral-100 tablet:pl-[3.2rem] tablet:w-[29.6rem] h-[32.8rem] tablet:h-full text-ui gap-medium"
    data-testid="intake-time-picker"
  >
    {heading && <div className="font-semibold text-ui">{heading}</div>}
    <div className="flex overflow-auto pl-[2px]">
      {availableTimes?.length ? (
        <RadioButtons
          id="time-slots"
          options={availableTimes.map((slot) => ({
            value: timeOfDayInMinutes(slot).toString(),
            label: formatTimeOfDay(slot),
          }))}
          value={
            selectedTime
              ? timeOfDayInMinutes(selectedTime).toString()
              : undefined
          }
          onChange={(value) => onSelect(toTimeOfDayFromMinutesString(value))}
        />
      ) : null}
    </div>
  </div>
);
